
import {defaultPhoneCode} from "./default";
export class RAMUser {
    constructor(contact) {
        this._id = '';
        this.title = '';
        this.first_name = '';
        this.second_name = '';
        this.surname = '';
        this.email = '';
        this.user_to_copy = '';
        this.phone_no = '';
        this.phone_code = defaultPhoneCode;
        this.reports_required = '';
        this.chargeback_access = '';
        this.chargeback_level = '';
        this.merchant_actions = '';

        if (!!contact) {
            this.setUserData(contact);
        }
    }

    setUserData(contact) {
        let business_data_keys = Object.keys(contact);
        business_data_keys.map(f => {
            this[f] = !!contact[f] ? contact[f] : '';
        });
    }
}
